
import { Variant as Variant_3 } from "../Variant.js";
import { Union, Record } from "../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { SupportMessageDto, SupportMessageResponse_$reflection, SupportMessageDto_$reflection } from "../Shared/Support.js";
import { FormState__getValidation, FormState__setValidationResponse_5219762A, FormState_get_empty, FormState__startLoading, ClientApiResponse$1_$reflection, FormState_$reflection } from "../Shared/Shared.js";
import { union_type, class_type, string_type, record_type } from "../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { Cmd_OfPromise_either } from "../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { fetchWithDecoder, addPrefix } from "../CommunicationV2.js";
import { Types_RequestProperties } from "../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { ofArray } from "../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { Reader_$ctor_Z3F6BC7B1, Reader__Read_24524716 } from "../fable_modules/Fable.Remoting.MsgPack.1.25.0/Read.fs.js";
import { Auto_generateBoxedEncoder_437914C6, toString } from "../fable_modules/Thoth.Json.10.4.1/Encode.fs.js";
import { Cmd_none } from "../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { Cmd_successToast } from "../Components/Toast.js";
import { createElement } from "react";
import React from "react";
import { reactApi, reactElement } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { isNullOrWhiteSpace, concat, join } from "../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { React_useElmish_Z6C327F2E } from "../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { useTranslation } from "react-i18next";
import { createObj } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { TextValue } from "../Components/Text.js";
import { TextButton, Button } from "../Components/Button.js";
import { TextArea } from "../Components/TextArea.js";
import { unwrap } from "../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { Input } from "../Components/Input.js";

export const supportMeetingUrl = (Variant_3.tag === 1) ? "https://meet.inventory-one.com/meetings/inventory-one/support-inventory-one" : "https://meet.inventory-one.com/meetings/inventory-one/support-meinwerkzeugkoffer";

export function helpCenterUrl(language) {
    switch (language) {
        case "en":
        case "fr":
        case "it":
        case "uk":
        case "nl":
        case "pl":
        case "hr":
        case "ro":
        case "sr":
        case "sq":
            return "https://help.inventory-one.com/knowledge-base-en";
        default:
            return "https://help.inventory-one.com/knowledge-base";
    }
}

function openInNewTab(url) {
    window.open(url, "_blank", "noreferrer");
}

class State extends Record {
    constructor(Dto, FormState) {
        super();
        this.Dto = Dto;
        this.FormState = FormState;
    }
}

function State_$reflection() {
    return record_type("Widgets.SupportHelp.State", [], State, () => [["Dto", SupportMessageDto_$reflection()], ["FormState", FormState_$reflection()]]);
}

class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["SupportMessageResponse", "SendSupportMessage", "SetMessage", "SetPhoneNumber", "FetchError"];
    }
}

function Msg_$reflection() {
    return union_type("Widgets.SupportHelp.Msg", [], Msg, () => [[["Item", ClientApiResponse$1_$reflection(SupportMessageResponse_$reflection())]], [], [["Item", string_type]], [["Item", string_type]], [["Item", class_type("System.Exception")]]]);
}

const emptyDto = new SupportMessageDto("", "");

function update(msg, state) {
    switch (msg.tag) {
        case 1:
            return [new State(state.Dto, FormState__startLoading(state.FormState)), Cmd_OfPromise_either((tupledArg) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                let url_2;
                return ((url_2 = addPrefix(tupledArg[0]), (refreshOn) => fetchWithDecoder(url_2, ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(2, [tupledArg[1]])]), "application/json", (response_1) => {
                    const pr = response_1.arrayBuffer();
                    return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), SupportMessageResponse_$reflection()));
                }, refreshOn)))(true);
            })), ["/api/support/message", toString(0, Auto_generateBoxedEncoder_437914C6(SupportMessageDto_$reflection(), undefined, undefined, undefined)(state.Dto))], (Item) => (new Msg(0, [Item])), (Item_1) => (new Msg(4, [Item_1])))];
        case 2:
            return [new State(new SupportMessageDto(state.Dto.PhoneNumber, msg.fields[0]), state.FormState), Cmd_none()];
        case 3:
            return [new State(new SupportMessageDto(msg.fields[0], state.Dto.Message), state.FormState), Cmd_none()];
        case 4:
            return [new State(state.Dto, FormState_get_empty()), Cmd_none()];
        default: {
            const response = msg.fields[0];
            if (response.tag === 1) {
                return [new State(state.Dto, FormState__setValidationResponse_5219762A(state.FormState, response.fields[0])), Cmd_none()];
            }
            else {
                return [new State(emptyDto, FormState_get_empty()), Cmd_successToast("support.message_sent")];
            }
        }
    }
}

function init() {
    return [new State(emptyDto, FormState_get_empty()), Cmd_none()];
}

function Section(props) {
    return reactElement("div", {
        className: join(" ", ["flex", "flex-col", "gap-3", "px-4", "py-4", "border-b", "border-border"]),
        children: reactApi.Children.toArray(Array.from(props.Children)),
    });
}

export function SupportHelpContent(props) {
    let elems_4, elems, elems_1, elems_2, elems_3, Label_4;
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(init, update, (_arg, _arg_1) => {
    }), undefined, []);
    const state_1 = patternInput[0];
    const dispatch = patternInput[1];
    const t = useTranslation()[0];
    const componentState = state_1.FormState.IsLoading ? "disabled" : "enabled";
    const phoneNumber = t("global.phone_number");
    return reactElement("div", createObj(ofArray([["data-test-id", "support-help-content"], ["className", join(" ", ["flex", "flex-col"])], (elems_4 = [createElement(Section, {
        Children: ofArray([createElement(TextValue, {
            FontWeight: "normal",
            TestId: "",
            Text: t("support.help_description"),
        }), reactElement("div", createObj(ofArray([["className", join(" ", ["flex"])], (elems = [createElement(Button, {
            ComponentState: "enabled",
            Label: t("support.help_button"),
            OnClick: () => {
                openInNewTab(helpCenterUrl(props.CurrentUser.Language));
            },
            TestId: "open-help-button-test-id",
            Variant: "primary",
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])))]),
    }), createElement(Section, {
        Children: ofArray([createElement(TextValue, {
            FontWeight: "normal",
            TestId: "",
            Text: t("support.meeting_message"),
        }), reactElement("div", createObj(ofArray([["className", join(" ", ["flex"])], (elems_1 = [createElement(Button, {
            ComponentState: "enabled",
            Label: t("support.meeting_button"),
            OnClick: () => {
                openInNewTab(supportMeetingUrl);
            },
            TestId: "send-support-meeting-dialog-button-test-id",
            Variant: "primary",
        })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))]),
    }), createElement(Section, {
        Children: ofArray([createElement(TextValue, {
            FontWeight: "normal",
            TestId: "support-phone-message-text",
            Text: t("support.phone_message"),
        }), reactElement("a", {
            className: join(" ", ["text-primary", "font-bold", "text-xl"]),
            href: concat("tel:", ...phoneNumber),
            children: phoneNumber,
        })]),
    }), createElement(Section, {
        Children: ofArray([reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-1"])], (elems_2 = [createElement(TextValue, {
            FontWeight: "normal",
            TestId: "",
            Text: t("support.send_message"),
        }), reactElement("a", {
            className: join(" ", ["font-semibold", "text-sm", "text-primary"]),
            href: "mailto:support@inventory-one.com",
            children: "support@inventory-one.com",
        })], ["children", reactApi.Children.toArray(Array.from(elems_2))])]))), createElement(TextArea, {
            ComponentState: componentState,
            Label: t("support.message"),
            OnChange: (value_19) => {
                dispatch(new Msg(2, [value_19]));
            },
            TestId: "support-message-textarea",
            ValidationMessage: unwrap(FormState__getValidation(state_1.FormState, t, "Message")),
            Value: state_1.Dto.Message,
        }), createElement(Input, {
            ComponentState: componentState,
            Label: t("support.your_phonenumber"),
            OnChange: (value_20) => {
                dispatch(new Msg(3, [value_20]));
            },
            TestId: "support-phone-number-input",
            Value: state_1.Dto.PhoneNumber,
        }), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-end"])], (elems_3 = [createElement(TextButton, (Label_4 = t("support.send"), {
            ComponentState: isNullOrWhiteSpace(state_1.Dto.Message) ? "disabled" : componentState,
            Label: Label_4,
            OnClick: () => {
                dispatch(new Msg(1, []));
            },
            TestId: "send-support-dialog-button-test-id",
            Variant: "blueButton",
        }))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])))]),
    })], ["children", reactApi.Children.toArray(Array.from(elems_4))])])));
}

